export default "__VITE_ASSET__gknMHESx__"